<template>
  <v-container>
    <page-title 
      title='ページが見つかりません。'/>
    <page-contents 
      :contents=info />
  </v-container>
</template>


<script>
import PageTitle from '@/components/PageTitle.vue'
import PageContents from '@/components/PageContents.vue'

export default {
  components: {
    PageTitle,
    PageContents,
  },
  data(){
    return{
      info: [
        '右上のボタンからお探しのページへ移動してください。'
      ],
    }
  }
};
</script>
